export default function loadingReducer (state = false, action) {
  if (action.type === 'INIT_LOADING') return true
  return false
}
